import { Team, User } from 'api/models';

export const isUser = (value: User | Team): value is User => {
  return (value as User).userId !== undefined;
};
